/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Locked_ByInputs */



/**
* | output |
* | --- |
* | "Locked By" |
*
* @param {Explorer_Info_Property_Locked_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_locked_by = /** @type {((inputs?: Explorer_Info_Property_Locked_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Locked_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouille par")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesperrt von")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bloccato da")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заблокировано пользователем")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueado por")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("锁定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロック者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("द्वारा बंद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trancado por")
	return /** @type {LocalizedString} */ ("Locked By")
});